export const ACCOUNT_ORDERS_LABEL = 'account.orders';
export const CHECKOUT_BAGPAGE_LABEL = 'checkout.bagPage';
export const BROWSE_PDP_LABEL = 'Browse.PDP';
export const lblNoLongerAvailable = 'lbl_orders_noLongerAvailable';
export const lblCancelledItems = 'lbl_orders_canceledItems';
export const lblBossOrderCancelNotification = 'lbl_orders_isBossOrderCancelNotification';
export const lblCancelNotification = 'lbl_orders_CancelNotification';
export const lblOutOfStock = 'lbl_orders_outOfStock';
export const lblOutOfStockNotification = 'lbl_orders_outOfStockNotification';
export const lblReturned = 'lbl_orders_returned';
export const lblOrderDetailsHeading = 'lbl_orderDetails_heading';
export const lblPrintText = 'lbl_orders_gift_receipt_print_text';
export const lblExpectedPickup = 'lbl_orders_expectedPickup';
export const lblBossStatus = 'lbl_orders_bossStatus';
export const lvlOrderDate = 'lbl_orderDetails_orderDate';
export const lblOrdersAt = 'lbl_orderDetails_at';
export const lblExpirationDate = 'lbl_orders_expirationDate';
export const lblOrdersEnding = 'lbl_orders_ending';
export const lblOrderDetailsBilling = 'lbl_orderDetails_billing';
export const lblOrdersOn = 'lbl_orders_on';
export const lblOrderReceived = 'lbl_orders_statusOrderReceived';
export const lblBeingProcessed = 'lbl_order_being_processed';
export const lblShippedToStore = 'lbl_shipped_to_store';
export const lblOrderDetailsShipped = 'lbl_orderDetails_shipment';
export const lblInitiatedNotification = 'lbl_orders_initiatedNotification';
export const lblEddDeliveredOn = 'lbl_edd_delivered_on';
export const lblOrderDetailsShippedOn = 'lbl_orderDetails_shipment_on';
export const lblEddArrivedBy = 'lbl_edd_arrivedby';
export const lblEstimatedToShipBy = 'lbl_estimated_to_ship_by';
export const lblOrderDetailsReceivedOn = 'lbl_orderDetails_received_on';
export const lblOrderOpenToday = 'lbl_orders_openToday';
export const lblOrdersPhone = 'lbl_orders_phone';
export const lblOrdersGetDirections = 'lbl_orders_getDirections';
export const lblOrdersPickupPerson = 'lbl_orders_pickupPerson';
export const lblOrdersReturnsCompleted = 'lbl_orders_returns_completed';
export const lblOrdersReturnsInitiated = 'lbl_orders_returns_initiated';
export const lblOrdersStatusItemsPickedUp = 'lbl_orders_statusItemsPickedUp';
export const lblPrintGiftReceipt = 'lbl_orderDetails_print_gift_receipt';
export const lblOrderDetailsShowBarcode = 'lbl_orderDetails_show_barcode';
export const lblNoReceiptsYet = 'lbl_orderDetails_no_receipts_yet';
export const lblProvidedOnceOrderShips = 'lbl_orderDetails_provided_once_order_ships';
export const lblBackToOrderDetails = 'lbl_orderDetails_back_to_order_details';
export const lblPrintReceipts = 'lbl_orderDetails_print_receipts';
export const lblShippedMultiplePackages = 'lbl_orderDetails_shipped_multiple_packages';
export const lblReceiptsShownBelow = 'lbl_orderDetails_receipts_shown_below';
export const lblReceiptMessageHeading = 'lbl_order_receipt_message_heading';
export const lblOtemNumber = 'lbl_orderDetails_itemnumber';
export const lblOrderDetailsQty = 'lbl_orderDetails_qty';
export const lblOrderDetailsReturnBy = 'lbl_orderDetails_return_by';
export const lblOrderDetailsColor = 'lbl_orderDetails_color';
export const lblOrderDetailsFit = 'lbl_orderDetails_fit';
export const lblOrderDetailsSize = 'lbl_orderDetails_size';
export const lblPreOrderTag = 'lbl_pre_order_tag';
export const lblOrderDetailsPrice = 'lbl_orderDetails_price';
export const lblYouPaid = 'lbl_orderDetails_youPaid';
export const lblQuantity = 'lbl_orderDetails_quantity';
export const lblSubTotal = 'lbl_orderDetails_subTotal';
export const lblWriteReview = 'lbl_orderDetails_writeReview';
export const lblOrdersAdjustment = 'lbl_orders_adjustment';
export const lblOrderDetailsUpc = 'lbl_orderDetails_upc';
export const lblOrdersTrackingNumber = 'lbl_orders_trackingNumber';
export const lblOrdersTrackIt = 'lbl_orders_trackit';
export const lblOrdersTrackingId = 'lbl_orders_trackingId';
export const lblOrdersTax = 'lbl_orders_tax';
export const lblOrdersOrderSummary = 'lbl_orderDetails_orderSummary';
export const lblOrdersOrderTotal = 'lbl_orders_orderTotal';
export const lblOrdersCouponsPromotions = 'lbl_orders_couponsPromotions';
export const lblOrdersFree = 'lbl_orders_free';
export const lblEmptyOrdersText4 = 'lbl_orderHistory_empty_orders_text4';
export const lblOrdersOrderStatus = 'lbl_orders_orderStatus';
export const lblFullOrderDetails = 'lbl_orders_fullOrderDetail';
export const lblOrderDetailHeading = 'lbl_orderDetail_heading';
export const lblOrdersReturnReceipt = 'lbl_orders_return_receipt';
export const lblReturnReceiptAddressHeading = 'lbl_return_address_receipt_us_heading';
export const lblReturnReceiptCaHeading = 'lbl_return_address_receipt_ca_heading';
export const lblOrdersOrderDate = 'lbl_orders_orderDate';
export const lblOrderReturnPayment = 'lbl_order_return_payment';
export const lblReturnMember = 'lbl_order_return_member';
export const lblOrdersCaOrdersLink = 'lbl_orders_caOrdersLink';
export const lblOrdersUsOrdersLink = 'lbl_orders_usOrdersLink';
export const lblInternationalOrdersLink = 'lbl_orders_internationalOrdersLink';
export const lblOrdersOrderType = 'lbl_orders_orderType';
export const lblOrdersPickupStore = 'lbl_orders_pickupStore';
export const lblOrdersOnline = 'lbl_orders_online';
export const lblOrdersViewDetails = 'lbl_orders_view_details';
export const lblOrderHelp = 'lbl_order_help';
export const lblHeadingStorePickUp = 'lbl_orders_heading_store_pickup';
export const lblHeadingStorePickUpExpired = 'lbl_orders_heading_store_pickup_expired';
export const lblOrderNotPicked2 = 'lbl_orders_notification_ordernotpicked_2';
export const lblNotificationCancelledItems = 'lbl_orders_notification_cancelled_items';
export const lblNotificationOrderPicked1 = 'lbl_orders_notification_ordernotpicked_1';
export const lblOrdersShowLess = 'lbl_orders_showLess';
export const lblOrdersShowMore = 'lbl_orders_showMore';
export const lblOrdersPastOrders = 'lbl_orders_pastOrders';
export const lblOrdersRecentOrders = 'lbl_orders_recentOrder';
export const lblPrderTileOrderNum = 'lbl_ordersTile_orderNum';
export const lblOrderTilePurchase = 'lbl_ordersTile_purchase';
export const lblWriteReviewLocation = 'lbl_write_review_location';
export const lblOrdersHeading = 'lbl_orders_heading';
export const lblOrdersHeadingUpcoming = 'lbl_orders_heading_upcoming';
export const lblExtendedLast6Months = 'lbl_orderHistory_extended_last6months';
export const lblExtendedLast12Months = 'lbl_orderHistory_extended_last12months';
export const lblOrdersHeadingHistory = 'lbl_orders_heading_history';
export const lblEmptyOrdersText1 = 'lbl_orderHistory_empty_orders_text1';
export const lblEmptyOrdersText2 = 'lbl_orderHistory_empty_orders_text2';
export const lblOrdersLoadMore = 'lbl_orders_load_more';
export const lblOrdersPurchasedItems = 'lbl_orders_purchasedItems';
export const lblOrdersRefundProcessed = 'lbl_orders_refund_processed';
export const lblOrdersItemReturned = 'lbl_orders_item_returned';
export const lblOrdersRefundInProgress = 'lbl_orders_refund_in_progress';
export const lblOrdersReturnInitiated = 'lbl_orders_return_initiated';
export const lblOrderPartiallyCancelled = 'lbl_orders_statusOrderPartiallyCancelled';
export const lblOrdersStatusCancelled = 'lbl_orders_statusOrderCancelled';
export const lblOrdersFetchingError = 'lbl_orders_fetchingError';
export const lblOrdersReceipt = 'lbl_orders_receipt';
export const lblOrdersPickUpFrom = 'lbl_orders_pickup_from';
export const lblOrderDetailsTrack = 'lbl_orderDetails_track';
export const lblOrderDetailsDirection = 'lbl_orderDetails_direction';
export const lblStatusShippingCancelled = 'lbl_orders_statusShippingCancelled';
export const lblOrdersProcessing = 'lbl_orders_processing';
export const lblStatusOrderReadyForPickup = 'lbl_orders_statusItemsReadyForPickup';
export const lblOrdersPreparing = 'lbl_orders_preparing';
export const lblHeadingInTransit = 'lbl_orders_heading__in_transit';
export const lblHeadingDelivered = 'lbl_orders_heading_delivered';
export const lblHeadingOutForDelivery = 'lbl_orders_heading_out_for_delivery';
export const lblOrdersShipped = 'lbl_orders_shipped';
export const lblOrdersReturnCompleted = 'lbl_orders_return_completed';
export const lblOrdersStatusOrderShipped = 'lbl_orders_statusOrderShipped';
export const lblStatusOrderExpired = 'lbl_orders_statusOrderExpired';
export const lblStatusOrderInProcess = 'lbl_orders_statusInProcess';
export const lblOrderPartiallyShipped = 'lbl_orders_statusOrderPartiallyShipped';
export const lblPartiallyDelivered = 'lbl_partially_delivered';
export const lblOrderDelivered = 'lbl_order_delivered';
export const lblStatusUserCallNeeded = 'lbl_orders_statusUserCallNeeded';
export const lblOrdersStatusNa = 'lbl_orders_statusNa';
export const lblOrdersShippedOn = 'lbl_orders_shippedOn';
export const lblOrderCancelMessage = 'lbl_orders_orderCancelMessage';
export const lblOrderInProcess = 'lbl_orders_orderInProcess';
export const lblOrderIsReadyForPickup = 'lbl_orders_orderIsReadyForPickup';
export const lblOrdersPickUpBy = 'lbl_orders_pleasePickupBy';
export const lblOrdersPickedUpOn = 'lbl_orders_pickedUpOn';
export const lblOrdersReceived = 'lbl_orders_OrderReceived';
export const lblRefundDisabledInitial = 'lbl_csh_refund_disabled_initial';
export const lblCshRedundDisabledEnding = 'lbl_csh_refund_disabled_ending';
export const lblCancelledDisabledInitial = 'lbl_csh_cancelled_disabled_initial';
export const lblCancelledDisabeldEnding = 'lbl_csh_cancelled_disabled_ending';
export const lblOrdersTotalItems = 'lbl_orders_totalItems';
export const lblSelectAnAction = 'lbl_csh_select_an_action';
export const lblEditOption = 'lbl_edit_option';
export const lblHelpAnotherOrder = 'lbl_help_another_order';
export const lblReviewSubmit = 'lbl_review_submit';
export const lblSeeMore = 'lbl_see_more';
export const lblErrCouponInactive = 'lbl_csh_err_coupon_inactive';
export const lblErrCouponInvalid = 'lbl_csh_err_coupon_invalid';
export const lblErrCouponExpired = 'lbl_csh_err_coupon_expired';
export const lblStatusItemsInTransit = 'lbl_orders_statusItemsInTransit';
export const lblStatusItemsDelivered = 'lbl_orders_statusItemsDelivered';
export const lblStatusItemsReceived = 'lbl_orders_statusItemsReceived';
export const lblOrdersStatusOrderPickUp = 'lbl_orders_statusOrderPickUp';
export const lblOrdersStatusOrderPicked = 'lbl_orders_statusOrderPicked';
export const lblOrdersStatusOrderExpiredAndRefunded = 'lbl_orders_statusOrderExpiredAndRefunded';
export const lblStatusItemsInProgress = 'lbl_orders_statusItemsInProgress';
export const lblEddArriveBy = 'lbl_edd_arrive_by';
export const lblSelectTheMissingItems = 'lbl_csh_select_the_missingItems';
export const lblSelectIncorrectItems = 'lbl_csh_select_the_incorrectItems';
export const lblSelectOneItem = 'lbl_select_only_one_item';
export const lblMultipleItemsCantSelect = 'lbl_csh_multiple_items_cant_selected';
export const lblCshInTransitMessage = 'lbl_csh_in_transit_message';
export const lblCshInProgressMsg = 'lbl_csh_in_progress_message';
export const lblCshReturnItemMessage = 'lbl_csh_returnItem_message';
export const lblCshReturned = 'lbl_csh_returned';
export const lblCshRefundItemMsg = 'lbl_csh_refundedItem_message';
export const lblCshRefunded = 'lbl_csh_refunded';
export const lblCshCancelled = 'lbl_csh_canceled';
export const lblCancelItemMsg = 'lbl_csh_cancelItem_message';
export const lblReturnInitiateItemMsg = 'lbl_csh_returninitiateItem_message';
export const lblCshReturning = 'lbl_csh_returning';
export const lblCshNotEligibleReturn = 'lbl_csh_not_eligible_return_message';
export const lblGcNotEligibleReturn = 'lbl_gift_card_not_eligble_return';
export const lblGcNonRefundable = 'lbl_gift_card_non_refundable';
export const lblOrdersTrackingCta = 'lbl_orders_tracking-cta';
export const lblOrderStatusProcessing = 'lbl_order_status_processing';

export const OrderDetailLabels = {
  account: {
    orders: {
      [lblOrdersTrackingCta]: 'Tracking#',
      [lblGcNonRefundable]: 'Non-returnable',
      [lblGcNotEligibleReturn]: 'Item(s) not eligible for returns',
      [lblCshNotEligibleReturn]: 'Not eligible for further returns',
      [lblCshReturning]: 'Returning',
      [lblReturnInitiateItemMsg]: 'Item(s) cannot be selected',
      [lblCancelItemMsg]: 'Cancelled item(s) cannot be selected',
      [lblCshCancelled]: 'Canceled',
      [lblCshRefunded]: 'Refunded',
      [lblCshRefundItemMsg]: 'Item(s) cannot be selected',
      [lblCshReturned]: 'Returned',
      [lblCshReturnItemMessage]: 'Item(s) not eligible for returns',
      [lblCshInTransitMessage]: 'Item(s) in transit cannot be selected',
      [lblMultipleItemsCantSelect]: 'Multiple items can be selected at a time',
      [lblSelectOneItem]: 'Only one item can be selected at a time',
      [lblSelectIncorrectItems]: 'Select the incorrect item',
      [lblSelectTheMissingItems]: 'Select the missing item(s)',
      [lblEddArriveBy]: 'Arrive By',
      [lblStatusItemsInProgress]: 'Order Processing',
      [lblStatusItemsDelivered]: 'Delivered',
      [lblOrdersStatusOrderShipped]: 'Shipped',
      [lblStatusItemsReceived]: 'Received',
      [lblOrdersStatusOrderPicked]: 'Order Picked',
      [lblOrdersStatusOrderPickUp]: 'Order Picked Up',
      [lblOrdersStatusOrderExpiredAndRefunded]: 'Expired And Refunded',
      [lblStatusItemsInTransit]: 'In Transit',
      [lblErrCouponExpired]: 'expired on',
      [lblErrCouponInvalid]: 'Invalid coupon/promo code; check the spelling or try another one.',
      [lblErrCouponInactive]: 'Coupon Code is inactive',
      [lblNoLongerAvailable]: 'No Longer Available: ',
      [lblCancelledItems]: 'Canceled Items: ',
      [lblBossOrderCancelNotification]:
        'The following has been removed from your order due to availability issues. The items will not be shipped. You will not be charged',
      [lblCancelNotification]: 'This order has been canceled and will not be shipped.',
      [lblOutOfStock]: 'Out of Stock: ',
      [lblOutOfStockNotification]:
        'Unfortunately some items were out of stock and could not be shipped. You have been fully refunded.',
      [lblReturned]: 'Returned Items:',
      [lblOrderDetailsHeading]: 'ORDER DETAILS',
      [lblPrintText]: 'Print Receipt',
      [lblExpectedPickup]: 'Expected Pickup Date',
      [lblBossStatus]: 'Status',
      [lvlOrderDate]: 'Order Date',
      [lblOrdersAt]: 'at',
      [lblExpirationDate]: 'Expiration Date',
      [lblOrdersEnding]: 'ending in',
      [lblOrderDetailsBilling]: 'Billing',
      [lblOrdersOn]: ' on',
      [lblOrderReceived]: 'Order Received',
      [lblBeingProcessed]: 'Order Processing',
      [lblShippedToStore]: 'Shipped To Store',
      [lblOrderDetailsShipped]: 'Shipment',
      [lblInitiatedNotification]:
        'Refunds are processed and issued within 7-10 business days after a return has been received.',
      [lblEddDeliveredOn]: 'Delivered On',
      [lblOrderDetailsShippedOn]: 'Shipped on',
      [lblEddArrivedBy]: 'Arriving by',
      [lblEstimatedToShipBy]: 'Estimated to ship by',
      [lblOrderDetailsReceivedOn]: 'Received on',
      [lblOrderOpenToday]: 'Open today',
      [lblOrdersPhone]: 'Phone',
      [lblOrdersGetDirections]: 'Get directions',
      [lblOrdersPickupPerson]: 'Pickup Person(s)',
      [lblOrdersReturnsCompleted]: 'Return(s) Completed',
      [lblOrdersReturnsInitiated]: 'Return(s) Initiated',
      [lblOrdersStatusItemsPickedUp]: 'Picked Up',
      [lblPrintGiftReceipt]: 'Print Gift Receipt ',
      [lblOrderDetailsShowBarcode]: 'Show this barcode at the register',
      [lblNoReceiptsYet]: 'No receipts yet!',
      [lblProvidedOnceOrderShips]: 'Your receipt(s) will be provided once your order ships.',
      [lblBackToOrderDetails]: 'Back to Order Details',
      [lblPrintReceipts]: 'Print Receipts',
      [lblShippedMultiplePackages]:
        'If your order shipped in multiple packages, there may be more than one barcode to scan.',
      [lblReceiptsShownBelow]: 'Your receipts for shipped items are shown below.',
      [lblReceiptMessageHeading]: 'Holiday Return Policy:',
      [lblOtemNumber]: 'Item#',
      [lblOrderDetailsQty]: 'QTY: ',
      [lblOrderDetailsReturnBy]: 'Return by ',
      [lblOrderDetailsColor]: 'Color: ',
      [lblOrderDetailsFit]: 'Fit: ',
      [lblOrderDetailsSize]: 'Size: ',
      [lblOrderDetailsPrice]: 'Price: ',
      [lblYouPaid]: 'You Paid: ',
      [lblQuantity]: 'Quantity: ',
      [lblSubTotal]: 'Subtotal: ',
      [lblWriteReview]: 'Write a Review',
      [lblOrdersAdjustment]: 'Adjustment',
      [lblOrderDetailsUpc]: 'UPC: ',
      [lblOrdersTrackingNumber]: 'Tracking number: ',
      [lblOrdersTrackIt]: 'TRACK IT',
      [lblOrdersTrackingId]: 'Track ID: ',
      [lblOrdersTax]: 'Tax',
      [lblOrdersOrderSummary]: 'Order Summary',
      [lblOrdersOrderTotal]: 'Total',
      [lblOrdersCouponsPromotions]: 'Coupons & Promotions',
      [lblOrdersFree]: 'FREE',
      [lblOrdersOrderStatus]: 'Status',
      [lblFullOrderDetails]: 'VIEW FULL ORDER DETAILS',
      [lblOrderDetailHeading]: 'ORDER',
      [lblOrdersReturnReceipt]: 'RETURN RECEIPT',
      [lblReturnReceiptAddressHeading]: 'For US Customers:',
      [lblReturnReceiptCaHeading]: 'For Canada Customers:',
      [lblOrdersOrderDate]: 'Order Date',
      [lblOrderReturnPayment]: 'Payment',
      [lblReturnMember]: 'Member Number',
      [lblOrdersCaOrdersLink]: 'Show Canadian Orders',
      [lblOrdersUsOrdersLink]: 'Show US Orders',
      [lblInternationalOrdersLink]: 'Show International Orders',
      [lblOrdersOrderType]: 'Order Type',
      [lblOrdersPickupStore]: 'Pick Up In Store',
      [lblOrdersOnline]: 'Online',
      [lblOrdersViewDetails]: 'View Details',
      [lblOrderHelp]: 'Order Help',
      [lblHeadingStorePickUp]: 'STORE PICKUP',
      [lblHeadingStorePickUpExpired]: 'Pickup Expired',
      [lblOrderNotPicked2]:
        '- no problem. A refund has been issued for your order. Please note it may take 1-3 business days for your refund to be credited to your account.',
      [lblNotificationCancelledItems]:
        'Please review the details of your order, as some items may have been cancelled and will not be shipped. You will not be charged for cancelled items. ',
      [lblNotificationOrderPicked1]: 'Your order was not picked up',
      [lblOrdersShowLess]: 'Show Less',
      [lblOrdersShowMore]: 'Show More',
      [lblOrdersPastOrders]: 'PAST ORDERS',
      [lblOrdersRecentOrders]: 'MOST RECENT ORDER',
      [lblPrderTileOrderNum]: 'Order No',
      [lblOrderTilePurchase]: 'Purchase',
      [lblOrdersHeading]: 'ORDERS',
      [lblOrdersHeadingUpcoming]: 'Upcoming Deliveries',
      [lblExtendedLast6Months]: 'Last 6 Months',
      [lblExtendedLast12Months]: '6 - 12 Months',
      [lblOrdersHeadingHistory]: 'Order History',
      [lblEmptyOrdersText1]: 'For orders older than 6 months, ',
      [lblEmptyOrdersText2]: 'modify your filter selection.',
      [lblOrdersLoadMore]: 'LOAD MORE ',
      [lblOrdersPurchasedItems]: 'Purchased Items: ',
      [lblOrdersRefundProcessed]: 'Refund Processed,',
      [lblOrdersItemReturned]: 'Item Returned',
      [lblOrdersRefundInProgress]: ' Refund in progress',
      [lblOrdersReturnInitiated]: 'Return Initiated',
      [lblOrderPartiallyCancelled]: 'Cancelled',
      [lblOrdersStatusCancelled]: 'Cancelled',
      [lblOrdersFetchingError]:
        'Thank You for shopping with us. We received your order and processing it and more details should be available soon. Please check back later for the status of your order',
      [lblOrdersReceipt]: 'RECEIPT',
      [lblOrdersPickUpFrom]: 'From',
      [lblOrderDetailsTrack]: 'Track',
      [lblOrderDetailsDirection]: 'Directions',
      [lblStatusShippingCancelled]: 'Cancelled',
      [lblOrderStatusProcessing]: 'Processing',
      [lblOrdersProcessing]: ' Processing',
      [lblStatusOrderReadyForPickup]: 'Ready For Pickup',
      [lblOrdersPreparing]: 'Preparing Order',
      [lblHeadingInTransit]: 'In Transit',
      [lblHeadingDelivered]: 'Delivered',
      [lblHeadingOutForDelivery]: 'Out For Delivery',
      [lblOrdersShipped]: 'Shipped',
      [lblOrdersReturnCompleted]: 'Return Completed',
      [lblOrdersStatusOrderShipped]: 'Shipped',
      [lblStatusOrderExpired]: 'Expired',
      [lblStatusOrderInProcess]: 'In Process',
      [lblOrderPartiallyShipped]: 'Partially Shipped',
      [lblPartiallyDelivered]: 'Partially Delivered',
      [lblOrderDelivered]: 'Delivered',
      [lblStatusUserCallNeeded]: 'Call Needed',
      [lblOrdersStatusNa]: 'N/A',
      [lblOrdersShippedOn]: 'Shipped on: ',
      [lblOrderCancelMessage]: 'This order has been canceled.',
      [lblOrderInProcess]: 'Order in Process:',
      [lblOrderIsReadyForPickup]: '- We will notify you when your order is ready for pickup',
      [lblOrdersPickUpBy]: 'Please pick up by: ',
      [lblOrdersPickedUpOn]: 'Picked up on: ',
      [lblOrdersReceived]: 'Order Received: ',
      [lblRefundDisabledInitial]: 'Sorry! This order has already been refunded. Please',
      [lblCshRedundDisabledEnding]: 'for any further assistance needed.',
      [lblCancelledDisabledInitial]:
        'Sorry! Our Virtual Shopping Assistant can only help with active orders. Please',
      [lblCancelledDisabeldEnding]: 'for assistance with canceled orders.',
      [lblOrdersTotalItems]: 'Total Items: ',
      [lblSelectAnAction]: 'Select an action',
      [lblEditOption]: 'Edit Option',
      [lblHelpAnotherOrder]: 'HELP WITH ANOTHER ORDER',
    },
  },
};

export const ORDER_DETAILS_PREORDER = {
  checkout: {
    bagPage: {
      [lblPreOrderTag]: 'Pre Order',
    },
  },
};

export const OrderTileDetailsLabels = {
  Browse: {
    PDP: {
      [lblWriteReviewLocation]: 'Location',
    },
  },
};

export const ReviewCshLabels = {
  account: {
    orders: {
      [lblReviewSubmit]: 'SUBMIT',
    },
  },
};

export const SelectOrderLabels = {
  account: {
    orders: {
      [lblSeeMore]: 'See More',
    },
  },
};
